// Wraper around <input type="text" />
import { TextReplacements } from "components/text_replacements";
import * as React from "react";
export class TextInput extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.render = () => (React.createElement("input", { value: this.state.text, type: this.props.numbersOnly ? "number" : "text", maxLength: this.props.maxLength, className: "ui-input", onFocus: e => { var _a; return (_a = this.props.onFocus) === null || _a === void 0 ? void 0 : _a.call(null); }, onChange: e => this.onChange(e), onBlur: e => this.onBlur(e), onKeyPress: e => this.onKeyPress(e), onKeyDown: e => this.onKeyDown(e), placeholder: this.props.placeholder, ref: this.ref }));
        this.state = { text: this.props.text };
    }
    componentWillUnmount() {
        this.props.onEnd(this.props.text, this.state.text);
    }
    onChange(event) {
        let value = event.target.value;
        this.setState({ text: event.target.value });
        this.props.onChange(value);
    }
    onKeyPress(event) {
        if (this.props.enableReplacements === true)
            TextReplacements.onKeyPress(this, event);
    }
    onKeyDown(event) {
        if (this.props.enableReplacements === true)
            TextReplacements.onKeyDown(this, event);
    }
    manuallySetText(newText, newCursorPosition) {
        this.setState({ text: newText }, () => this.ref.current.setSelectionRange(newCursorPosition, newCursorPosition));
        this.props.onChange(newText);
    }
    onBlur(event) {
        this.props.onEnd(this.props.text, this.state.text);
    }
}
